export const ADD_TO_ORDER = "ADD_TO_ORDER";
export const DEC_FROM_ORDER = "DEC_FROM_ORDER";


// WEBPACK FOOTER //
// ./src/store/actions/actions.js